import { Button, Card, notification, Space, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { DELETE, POST } from "../../utils/apicalls";
import PageHeader from "../pageHeader/pageheader";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";

const { Title } = Typography;

function InvoiceIndex() {
  const navigate = useNavigate();

  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchInvoice = async () => {
    try {
      setIsLoading(true);
      const obj = {
        query: "query",
        page: 1,
        take: 1000, // load enough data to filter on frontend
      };
      const url = API.LIST_INVOICE;
      const response: any = await POST(url, obj);
      setData(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, []);

  const deleteInvoice = async (id: any) => {
    try {
      setIsLoading(true);
      const url = API.DELETE_INVOICE + id;
      const res: any = await DELETE(url);

      if (res.status) {
        notification.success({ message: "Invoice Deleted Successfully" });
        fetchInvoice();
      } else {
        notification.error({ message: "Something went wrong. Try again later." });
      }
    } catch (error) {
      console.error(error);
      notification.error({ message: "Something went wrong. Try again later." });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "id",
      title: "ID",
    },
    {
      dataIndex: "billNumber",
      title: "Bill Number",
    },
    {
      dataIndex: "billDate",
      title: "Bill Date",
      render: (date: any) => moment(date).format("DD/MM/YYYY"),
    },
    {
      dataIndex: "customerName",
      title: "Customer Name",
    },
    {
      dataIndex: "finalAmount",
      title: "Final Amount",
    },
    {
      dataIndex: "customerAddress",
      title: "Customer Address",
    },
    {
      title: "View/Edit",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            style={{ color: "blue", cursor: "pointer" }}
            size={20}
            onClick={() => navigate(`/Admin/Invoice/viewinvoice/${record?.id}`)}
          />
        </Space>
      ),
    },
    {
      title: "Delete",
      render: (_: any, record: any) => (
        <Space size="middle">
          <DeleteOutlined
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => deleteInvoice(record?.id)}
          />
        </Space>
      ),
    },
  ];

  // ✅ GST Bills
  const gstBills = data.filter(item =>
    item.customerGSTNumber &&
    item.customerGSTNumber !== "0" &&
    item.customerGSTNumber !== 0 &&
    item.customerGSTNumber !== "null" &&
    item.customerGSTNumber !== null &&
    item.customerGSTNumber.trim() !== ""
  );

  // ✅ Non-GST Bills
  const nonGstBills = data.filter(item =>
    !item.customerGSTNumber ||
    item.customerGSTNumber === "0" ||
    item.customerGSTNumber === 0 ||
    item.customerGSTNumber === "null" ||
    item.customerGSTNumber === null ||
    item.customerGSTNumber.trim() === ""
  );


  return (
    <div>
      <PageHeader title="Invoice List">
        <Button onClick={() => navigate(`/Admin/Invoice/createinvoice`)}>
          Create Invoice
        </Button>
      </PageHeader>

      <Card style={{ marginBottom: 24 }}>
        <Title level={4}>GST Bills</Title>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={gstBills}
          rowKey="id"
          pagination={{ pageSize: 5, showSizeChanger: true }}
        />
      </Card>

      <Card>
        <Title level={4}>Non-GST Bills</Title>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={nonGstBills}
          rowKey="id"
          pagination={{ pageSize: 5, showSizeChanger: true }}
        />
      </Card>
    </div>
  );
}

export default InvoiceIndex;
